
import RequestFeature from '@/views/Automation/CampaignCreatorV2/components/CcRequestFeature/RequestFeature.ts.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    RequestFeature,
  },
  props: {
    id: String,
    value: Boolean,
    text: String,
    info: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    requestFeature: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCheckboxClick(value: boolean) {
      this.$emit('update', value);
    },
  },
});
